module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/Desktop/sailing-work/mapbox/mapboxProject/node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/define-property.js
// module id = liLe
// module chunks = 1